module.exports = __webpack_public_path__ + "static/img/5644.8dddfab1.png";